import axios from 'axios';
import { CURRENT_API_URL } from "../../Utils/Constants";
import notify from '../../Notifications/ToastifyActions';


function UpdateProfilesV3Service(token, data) {
    
    // id in productDetails is either a field called asin or a field called integerId
    return axios.post(`${CURRENT_API_URL}/sellerPartner/UpdateProfilesV3APIFromUI`, data, {
        
        headers: {
            'Authorization': token,
        }
    }).then( notify.NotifySuccess("Profiles are getting updated."))      
        .then(res => {
            notify.NotifySuccess("Profiles have been saved in DB.")
            return res.data;
        }).catch(() => {
            notify.NotifyError("An error occurred while updating profile.");
            return false;
        });
}

export {
    UpdateProfilesV3Service,
}